export const rupiah = (n) =>
  "Rp " + new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

export const yuan = (n) => "¥" + new Intl.NumberFormat("zh-CN").format(n || 0);
